
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2849"}},[_c('g',{attrs:{"data-name":"Group 2848"}},[_c('path',{attrs:{"data-name":"Path 1757","d":"M93.75 106.25V24.219h-5.859a87.891 87.891 0 1087.891 87.891v-5.859z"}})])]),_c('g',{attrs:{"data-name":"Group 2851"}},[_c('g',{attrs:{"data-name":"Group 2850"}},[_c('path',{attrs:{"data-name":"Path 1758","d":"M112.109 0h-5.859v93.75H200v-5.859A87.987 87.987 0 00112.109 0z"}})])])])
          )
        }
      }
    